/**
 * Brand-wide constants. Single source of truth per hostname/dominio di brand.
 *
 * Override possibile via env `BRAND_BASE_DOMAIN` (rebrand multi-tenant white-label),
 * default produzione `easyflowai.it`.
 *
 * NON usare per generare URL pubblici hardcoded di servizi specifici
 * (media.*, fiscal.*, api.*) — quelli restano gestiti da env dedicati
 * (`PUBLIC_*_URL`, `LIVEKIT_URL`, `FISCAL_AGENT_PUBLIC_URL`) per consentire
 * cutover infra senza ricompilare codice.
 *
 * Usare SOLO per:
 *   1. Generazione default SIP domain di un tenant nuovo (`<slug>.${BRAND_BASE_DOMAIN}`)
 *   2. CORS allowlist origini fidate (`*.${BRAND_BASE_DOMAIN}` su HTTPS)
 *   3. Validazione formato SIP domain (regex anchored sul brand)
 */

function readBrandBaseDomain(): string {
  if (typeof process !== 'undefined' && process.env && typeof process.env.BRAND_BASE_DOMAIN === 'string') {
    const v: string = process.env.BRAND_BASE_DOMAIN.trim().toLowerCase();
    if (v.length > 0) return v;
  }
  return 'easyflowai.it';
}

export const BRAND_BASE_DOMAIN: string = readBrandBaseDomain();

/**
 * Costruisce un SIP domain default a partire da uno slug tenant.
 * Slug deve essere già sanitizzato (lowercase, [a-z0-9-]).
 */
export function buildDefaultSipDomain(slug: string): string {
  return `${slug}.${BRAND_BASE_DOMAIN}`;
}

/**
 * Regex per validazione SIP domain conforme al brand corrente.
 * Costruita dinamicamente da BRAND_BASE_DOMAIN per evitare drift.
 */
export function brandSipDomainRegex(): RegExp {
  const escaped: string = BRAND_BASE_DOMAIN.replace(/\./g, '\\.');
  return new RegExp(`^[a-z0-9-]+\\.${escaped}$`);
}
